// ── InvoiceCard ───────────────────────────────────────────────────────────────

import { Link } from "react-router-dom";
import type { Invoice, Transaction } from "@/application/money/types";
import { formatCurrency } from "@/application/money/types";
import { MoneyStatusBadge } from "./MoneyStatusBadge";
import { ROUTES } from "@/routes";

interface InvoiceCardProps {
  invoice: Invoice;
  transaction: Transaction;
}

export function InvoiceCard({ invoice, transaction: tx }: InvoiceCardProps) {
  const invoicesListUrl =
    ROUTES.MERCHANT_DETAIL.replace(":businessId", tx.businessId) +
    "?money=invoices";

  return (
    <div className="bg-card rounded-lg border p-5">
      <h2 className="text-foreground mb-3 text-sm font-semibold">Invoice</h2>

      <div className="divide-y text-sm">
        <div className="flex justify-between py-2.5">
          <span className="text-muted-foreground">Invoice ID</span>
          <span className="text-foreground font-mono text-xs">
            {invoice.id}
          </span>
        </div>

        <div className="flex justify-between py-2.5">
          <span className="text-muted-foreground">Status</span>
          {invoice.status ? (
            <MoneyStatusBadge status={invoice.status} />
          ) : (
            <span className="text-subtle-foreground">—</span>
          )}
        </div>

        <div className="flex justify-between py-2.5">
          <span className="text-muted-foreground">Amount</span>
          <span className="text-foreground font-medium">
            {formatCurrency(invoice.amount, invoice.currency)}
          </span>
        </div>

        {invoice.recipient && (
          <div className="flex justify-between py-2.5">
            <span className="text-muted-foreground">Recipient</span>
            <span className="text-foreground">{invoice.recipient.name}</span>
          </div>
        )}

        <div className="pt-3">
          <Link
            to={invoicesListUrl}
            className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
          >
            View invoices for this merchant →
          </Link>
        </div>
      </div>
    </div>
  );
}
